import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS } from "@/lib/i18n";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useTranslation } from "react-i18next";
import { getAppsAlertCounts } from "./-query/api";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute("/_staff/apps/_list/alerts/_alerts")({
  validateSearch: zodValidator(SearchSchema),
  component: AppsAlerts,
  loader: getAppsAlertCounts,
});

function AppsAlerts() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.apps.alert",
  });
  useDocumentTitle(t("pageTitle"));

  return <Outlet />;
}
